import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { organizationQueryOptions } from '@/core/components/organizations/organizationQueryOptions'
import { propertiesQueryOptions } from '@/core/components/sites/propertyQueryOptions'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/dashboard/sites/create/')({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Editor'] ||
      auth.user?.role === Role['Blogger']
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth } }) => {
    const properties = queryClient.ensureQueryData(
      propertiesQueryOptions(auth.token!)
    )

    const organizations = queryClient.ensureQueryData(
      organizationQueryOptions(auth.token!)
    )

    return { properties, organizations }
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
